export default __webpack_public_path__ + "static/media/hint.43bf5ce5.svg";